import React from "react";
import { FiX } from "react-icons/fi";

export default function ImageViewModal({ isOpen, onClose, imageSrc, title }) {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="relative bg-white rounded-2xl shadow-2xl max-w-4xl max-h-[90vh] w-full mx-4 overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* HEADER */}
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
            aria-label="Close modal"
          >
            <FiX size={24} className="text-gray-600" />
          </button>
        </div>

        {/* IMAGE CONTENT */}
        <div className="p-6 flex items-center justify-center bg-gray-50 min-h-[400px]">
          <img
            src={imageSrc}
            loading="lazy"
            alt={title}
            className="max-w-full max-h-[70vh] object-contain rounded-lg shadow-md"
          />
        </div>
      </div>
    </div>
  );
}
